<div>
    <div class="modal-header py-1 border-0">
        <h4 class="modal-title pull-left"><b>Reason For churn</b></h4>
        <!-- <span (click)="closedModal()"><i class="bi bi-x-lg"></i></span> -->
    </div>
    <div>
        <form [formGroup]="remarkForm">
            <div class="modal-body pt-0 pb-0 mt-0">
                <div>
                    <!-- Category Field -->
                    <div class="row mb-3">
                        <label class="form-label mb-0"><b>Category</b></label>
                        <div class="mt-2">
                            <select class="form-select text-muted" formControlName="category">
                                <option value="" disabled>Select category</option>
                                <option *ngFor="let category of (isExpired ? categoryList  : trialExpired)" [value]="category">{{ category }}</option>
                            </select>
                            <div class="text-danger mt-1"
                                *ngIf="remarkForm.get('category')?.invalid && (remarkForm.get('category')?.dirty || remarkForm.get('category')?.touched)">
                                Category is required.
                            </div>
                        </div>
                    </div>

                    <!-- Remark Field -->
                    <div class="row mb-3">
                        <label class="form-label mb-0"><b>Remark</b></label>
                        <div class="mt-2">
                            <input type="text" placeholder="Enter Remark" class="form-control" formControlName="remark">
                            <div class="text-danger mt-1"
                                *ngIf="remarkForm.get('remark')?.invalid && (remarkForm.get('remark')?.dirty || remarkForm.get('remark')?.touched)">
                                Remark is required.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer border-0 pe-4">
                <div class="text-end border-0">
                    <button type="button" class="comman-btn1 btn-primary me-2" (click)="onSubmit()">Submit</button>
                    <button type="button" class="comman-btn1 btn-secondary text-light"
                        (click)="bsModalRef.hide()">Cancel</button>
                </div>
            </div>
        </form>

    </div>
</div>